import { Pipe, PipeTransform } from '@angular/core';
import { Event } from '../model/event';

@Pipe({
  name: 'eventsFilter'
})
export class EventsFilterPipe implements PipeTransform {

  public transform(value, test) {
  if (!test) {
    return value;
  }

  const normalize = (str: string) =>
    str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

  const filtered = value.filter(item => {
    let testingString = item['formattedName'] || '';
    if (item['subEvents']) {
      testingString += ' ' + item['subEvents'].map(subevent => subevent.formattedName).join(' ');
    }

    return normalize(testingString).includes(normalize(test));
  });

  return this.sortEvents(filtered);
}


  private sortEvents(events: any[]): any[] {
    return events.sort((a, b) => {
      if (b.year !== a.year) {
        return b.year - a.year; 
      }
      return b.id - a.id;
    });
  }
}